import { EventEmitter, Component, Input, Output } from '@angular/core';
import { Property } from 'src/typings';
import { PropertyService } from '../property.service';

@Component({
  selector: 'app-catalogue-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss']
})
export class PropertiesComponent {
  allProperties: { property: Property; folder_id?: number }[] = [];

  @Input() clearEvent: EventEmitter<boolean> = new EventEmitter();

  @Input() set folder_id(value: number | undefined) {
    if (!value) return;
    this.allProperties = [];
    this._folder_id = value;
    this.updateProps();
  }

  get folder_id() {
    return this._folder_id;
  }

  _folder_id: number | undefined;

  @Input() selectedProperties: Array<{
    property_id: number;
    values: string[];
  }> = [];

  @Output() AddPropertyEvent: EventEmitter<{
    property_id: number;
    value: string;
  }> = new EventEmitter();

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onRemovePropertyEvent: EventEmitter<{
    property_id: number;
    value: string;
  }> = new EventEmitter();

  constructor(private propertyService: PropertyService) {
    // this.propertyService.getList().subscribe((properties) => {
    //   this.allProperties = properties.map((property) => {
    //     return { property, folder_id: this.folder_id };
    //   });
    // });
  }

  onAddProperty(payload: { property_id: number; value: string }) {
    this.AddPropertyEvent.emit(payload);
  }

  onRemoveProperty(payload: { property_id: number; value: string }) {
    this.onRemovePropertyEvent.emit(payload);
  }

  updateProps() {
    if (!this.folder_id) return;
    this.allProperties = [];
    this.propertyService.search({ folder_id: this.folder_id }).subscribe((list) => {
      this.allProperties = list.map((property) => {
        return { property, folder_id: this.folder_id };
      });
    });
  }
}
